import { onBeforeUnmount } from 'vue'

const DEFAULT_OBSERVER_OPTIONS = { threshold: 0.1 }

export function useLazyImages({ onIntersect, observerOptions = DEFAULT_OBSERVER_OPTIONS } = {}) {
  let observer = null

  const observe = (images) => {
    if (observer) observer.disconnect()
    observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return
        onIntersect(entry.target)
        obs.unobserve(entry.target)
      })
    }, observerOptions)
    Array.from(images).forEach(img => observer.observe(img))
  }

  const disconnect = () => {
    if (observer) observer.disconnect()
    observer = null
  }

  onBeforeUnmount(disconnect)

  return { observe, disconnect }
}
